// extracted by mini-css-extract-plugin
export default {"modal":"popup_modal__rOMWX","active":"popup_active__0MgdR","modalContent":"popup_modalContent__Ag6Ya"};